import jQuery from "jquery";
import { TweenLite } from 'gsap';
import { ACTION, Events } from '../events'
import { VARS } from '../vars'

jQuery(document).ready(function($){
    let isMenuCompact = false
    
    if ($('.floating-box-container').length == 0 && $('.floating-menu-container').length == 0) {
        return false
    }


    // if there is more than one floating box, we need to move them to first container one and remove others
    const $floatingBox = $('.floating-box-container');
    const $stickyBoxWrappers = $('.sticky-box-wrapper').not('.author-box');
    if($floatingBox.length > 1 && $stickyBoxWrappers.length > 0) {

        $floatingBox.first().find('.sticky-box-container').html($stickyBoxWrappers.each(function() {
            return $(this)[0].outerHTML;
        }));

        $floatingBox.not(":first").remove();
    }

    let update = function() {
        let dataSectionsSpecialty = []
        let _move = 0

        $('.et_section_specialty').each(function() {
            let $this =  $(this)
            let $pinnedSibling = undefined
            let $pinnedBox = $this.find('.floating-box-wrapper')

            if ($this.find('.floating-menu-wrapper').length > 0) {
                $pinnedBox = $this.find('.floating-menu-wrapper')
            }

            if ($pinnedBox.length == 0) {
                $pinnedSibling = $this.find('.et_pb_row').first()
            } else {
                $pinnedSibling = $pinnedBox.parent().parent().parent().parent().next()
            }

            // reset heights - ready to set new values
            $pinnedBox.css('height', '')
            $pinnedSibling.css('min-height', '')
            
            let _data = {
                height: $pinnedSibling.outerHeight(),
                hasFloatingBox: $pinnedBox.length > 0,
                $pinnedBox,
                $pinnedSibling
            }

            dataSectionsSpecialty.push( _data )
        });

        // iterate on sections and define newHeight - it is sum of section
        // with floatingBox and empty sectios below
        $.each(dataSectionsSpecialty, function(index, data) {
            let newHeight = data.height

            if (data.hasFloatingBox) {
                let i = index
                
                while (dataSectionsSpecialty[i + 1] && dataSectionsSpecialty[i + 1].hasFloatingBox == false) {
                    newHeight += dataSectionsSpecialty[i + 1].height
                    i++
                }
            }

            dataSectionsSpecialty[index].newHeight = newHeight - 80
        })

        // remove sections from object that hasn't floatingBox
        dataSectionsSpecialty = dataSectionsSpecialty.filter(obj => obj.hasFloatingBox)

        // do animation, set new values
        $.each(dataSectionsSpecialty, function(index, data) {   
            let { $pinnedBox, $pinnedSibling, newHeight } = data
            let scrollWay = 'auto'

            if (window.innerWidth > 980) {
                scrollWay = newHeight ? newHeight : $pinnedSibling.outerHeight() - 80
            }
            
            $pinnedSibling.css('min-height', $pinnedBox.outerHeight())
            $pinnedBox.css('height', scrollWay)

            // only for small adjustment menu offset while nav is not comapct
            if ( $pinnedBox.parent().hasClass('floating-menu-container') ) {

                if (!isMenuCompact) {
                    _move = VARS.scrollTop > 70 ? 70 : VARS.scrollTop
                }
                
                TweenLite.to( $pinnedBox.parent(), 0.4, {
                    y: _move
                })   
            }
        })        
    }

    let setEvents = function() {
        Events.on(ACTION.RESIZE, update)

        Events.on(ACTION.SCROLL, () => {
            update()
        })

        Events.on(ACTION.MENU_COMPACT_ACTIVE, () => {
            isMenuCompact = true
            update()
        })

        Events.on(ACTION.MENU_COMPACT_INACTIVE, () => {
            isMenuCompact = false
            update()
        })
    }

    let init = function() {
        setEvents()
        update()
    }

    init();

});